import React, { useContext, useEffect, useMemo } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { UI } from "@wwimmo/ui";
import { v4 as uuidv4 } from "uuid";
import { RootStoreContext } from "src/stores/RootStore";
import { SCREEN_SIZE } from "src/stores/UIStore";
import { getNewsEditRoute } from "src/utils/NewsRoutes";
import { NewsOverviewToolbar } from "./toolbar/NewsOverviewToolbar";
import { NewsOverviewList } from "./list/NewsOverviewList";
import styles from "./NewsOverview.module.css";

// The page "News": all news of the customer, independent of a realestate. Built like the page "Tickets".
const NewsOverviewBase = () => {
    const { t } = useTranslation();
    const { navStore, authStore, uiStore, newsListStore } = useContext(RootStoreContext);

    useEffect(() => {
        navStore.setTitle(t("screens.news.title"));
        navStore.setActionButtonMiddle(null);
        navStore.setActionButtonRight(null);
        navStore.setBackbutton(null);
    }, [navStore, t]);

    useEffect(() => {
        newsListStore.loadNews();

        return newsListStore.clearNews;
    }, [newsListStore]);

    // Like on the realestate, the link to the mask already carries the id of the new news.
    const newNewsRoute = useMemo(
        () => getNewsEditRoute(uuidv4(), undefined, authStore.user?.role),
        [authStore.user?.role]
    );

    return (
        <UI.Container
            className={`pt-5 ${styles.NewsOverviewContainer} ${
                uiStore.currentScreenSize <= SCREEN_SIZE.LAPTOP ? styles.MinPadding : ""
            }`}
            fluid
        >
            <UI.Row className="mb-2">
                <UI.Col xs={12} sm={8}>
                    <UI.Title>{t("screens.news.title")}</UI.Title>
                </UI.Col>
                <UI.Col xs={12} sm={4}>
                    <UI.Button to={newNewsRoute} label={t("screens.realestate.dashboard.enter_new_news")} />
                </UI.Col>
            </UI.Row>
            <UI.Row>
                <UI.Col xs={12}>
                    <NewsOverviewToolbar />
                </UI.Col>
            </UI.Row>
            <UI.Row>
                <UI.Col xs={12}>
                    <NewsOverviewList />
                </UI.Col>
            </UI.Row>
        </UI.Container>
    );
};

export const NewsOverview = Sentry.withProfiler(observer(NewsOverviewBase));
